import { requestPermission } from "../../firebase/messaging";

// ================= REGEX =================
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phonePattern = /^[6-9]\d{9}$/;

// ================= SEND OTP =================
export async function sendOtp(identifier) {
  try {
    console.log("====================================");
    console.log("🚀 SEND OTP STARTED");
    console.log("====================================");

    const input = identifier.trim();

    console.log("📝 INPUT:", input);

    // ✅ CHECK EMAIL / PHONE
    const isEmail = emailPattern.test(input);
    const isPhone = phonePattern.test(input);

    console.log("📧 isEmail:", isEmail);
    console.log("📱 isPhone:", isPhone);

    // ❌ INVALID
    if (!isEmail && !isPhone) {
      console.log("❌ INVALID IDENTIFIER");

      return {
        error: "Enter valid email or mobile number",
      };
    }

    // ✅ QUERY PARAM API
    const apiUrl = isEmail
      ? `${
          process.env.REACT_APP_API_URL
        }Auth/SignupOrLogin?emailId=${encodeURIComponent(input)}`
      : `${
          process.env.REACT_APP_API_URL
        }Auth/SignupOrLogin?phoneNumber=${encodeURIComponent(input)}`;

    console.log("🌐 FINAL API URL:");
    console.log(apiUrl);

    console.log("📡 SENDING OTP REQUEST...");

    // ✅ API CALL
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        accept: "*/*",
      },
    });

    console.log("📡 RESPONSE STATUS:", response.status);

    // ✅ RAW RESPONSE
    const rawText = await response.text();

    console.log("📩 RAW RESPONSE:");
    console.log(rawText);

    // ✅ SUCCESS
    if (response.ok) {
      console.log("✅ OTP SENT SUCCESSFULLY");

      return {
        success: rawText || "OTP sent successfully",
      };
    }

    // ❌ FAILED
    console.log("❌ SEND OTP FAILED");

    return {
      error: rawText || "Failed to send OTP",
    };
  } catch (error) {
    console.log("🔥 SEND OTP ERROR:");
    console.log(error);

    return {
      error: "Something went wrong while sending OTP",
    };
  }
}

// ================= VERIFY OTP =================
export async function verifyOtp(identifier, otp) {
  console.log("====================================");
  console.log("🚀 VERIFY OTP FUNCTION STARTED");
  console.log("====================================");

  try {
    // ✅ INPUT CLEAN
    const input = identifier.trim();

    console.log("📝 RAW IDENTIFIER:", identifier);
    console.log("🧹 CLEAN IDENTIFIER:", input);

    // ✅ CHECK TYPE
    const isEmail = emailPattern.test(input);
    const isPhone = phonePattern.test(input);

    console.log("📧 isEmail:", isEmail);
    console.log("📱 isPhone:", isPhone);

    // ❌ INVALID
    if (!isEmail && !isPhone) {
      console.log("❌ INVALID IDENTIFIER");

      return {
        error: "Invalid email or mobile number",
      };
    }

    // ✅ OTP CLEAN
    const cleanOtp = String(otp).trim();

    console.log("🔢 RAW OTP:", otp);
    console.log("🧹 CLEAN OTP:", cleanOtp);
    console.log("🔢 OTP LENGTH:", cleanOtp.length);

    // ❌ INVALID OTP
    if (cleanOtp.length !== 6) {
      console.log("❌ OTP LENGTH INVALID");

      return {
        error: "OTP must be 6 digits",
      };
    }

    // ================= GET FCM TOKEN =================
    let fcmToken = "";

    try {
      console.log("====================================");
      console.log("📲 REQUESTING FCM TOKEN...");
      console.log("====================================");

      fcmToken = await requestPermission();

      console.log("====================================");
      console.log("✅ FCM TOKEN RECEIVED:");
      console.log("====================================");

      console.log(fcmToken);

      // ✅ EXTRA DEBUG
      localStorage.setItem("debugFCMToken", fcmToken);

      console.log(
        "💾 LOCAL STORAGE TOKEN:",
        localStorage.getItem("debugFCMToken")
      );

    } catch (tokenError) {
      console.log("====================================");
      console.log("❌ FCM TOKEN ERROR:");
      console.log("====================================");

      console.log(tokenError);
    }

    // ================= FINAL PAYLOAD =================
    let payload = {
      otp: cleanOtp,
      deviceToken: fcmToken || "",
      deviceType: "Android",
    };

    // 📱 PHONE LOGIN
    if (isPhone) {
      payload.phoneNumber = input;
    }

    // 📧 EMAIL LOGIN
    if (isEmail) {
      payload.emailId = input;
    }

    console.log("====================================");
    console.log("📦 FINAL VERIFY PAYLOAD");
    console.log("====================================");

    console.log(payload);

    console.log("====================================");
    console.log("📦 JSON PAYLOAD");
    console.log("====================================");

    console.log(JSON.stringify(payload, null, 2));

    // ================= API URL =================
    const apiUrl = `${process.env.REACT_APP_API_URL}Auth/VerifyOtp`;

    console.log("====================================");
    console.log("🌐 API URL");
    console.log("====================================");

    console.log(apiUrl);

    console.log("====================================");
    console.log("📡 SENDING VERIFY REQUEST...");
    console.log("====================================");

    // ================= VERIFY API =================
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    console.log("====================================");
    console.log("📩 API RESPONSE RECEIVED");
    console.log("====================================");

    console.log("📡 STATUS:", response.status);
    console.log("📡 STATUS TEXT:", response.statusText);
    console.log("📡 RESPONSE OK:", response.ok);

    // ================= RAW RESPONSE =================
    const rawResponse = await response.text();

    console.log("====================================");
    console.log("📩 RAW RESPONSE");
    console.log("====================================");

    console.log(rawResponse);

    // ================= JSON PARSE =================
    let data = {};

    try {
      data = JSON.parse(rawResponse);

      console.log("====================================");
      console.log("✅ JSON PARSED SUCCESS");
      console.log("====================================");

      console.log(data);

    } catch (err) {

      console.log("====================================");
      console.log("❌ JSON PARSE FAILED");
      console.log("====================================");

      console.log(err);

      data = {
        message: rawResponse,
      };
    }

    // ================= SUCCESS =================
    if (response.ok && (data?.succeeded || data?.success)) {

      console.log("====================================");
      console.log("✅ OTP VERIFIED SUCCESSFULLY");
      console.log("====================================");

      console.log("👤 USER DATA:", data?.data);
      console.log("🔑 TOKEN:", data?.token);

      // ✅ FINAL USER DATA
      const userData = {
        ...(data?.data || {}),

        emailId: isEmail ? input : "N/A",

        phoneNumber: isPhone ? input : "N/A",

        fcmToken: fcmToken || "",
      };

      console.log("====================================");
      console.log("✅ FINAL USER DATA:");
      console.log("====================================");

      console.log(userData);

      return {
        success: true,
        user: userData,
        token: data?.token || "",
      };
    }

    // ================= FAILED =================
    console.log("====================================");
    console.log("❌ OTP VERIFICATION FAILED");
    console.log("====================================");

    console.log("❌ BACKEND MESSAGE:", data?.message);

    return {
      error: data?.message || "OTP verification failed",
    };

  } catch (error) {

    console.log("====================================");
    console.log("🔥 VERIFY OTP ERROR");
    console.log("====================================");

    console.log(error);

    return {
      error: "Something went wrong while verifying OTP",
    };
  }
}